import {addScrollDeeplinkItemAction} from 'app/modules/scrollDeeplink/actions';

export function addLazyScroll(cId: string) {
    const hash = window.location.hash.substring(1);
    const collapseIdInUrl = new RegExp(`/?${cId}`).test(hash);
    if (collapseIdInUrl) {
        addScrollDeeplinkItemAction({type: 'LAZY_SCROLL', component: 'TOGGLE', cId});
        return true;
    }

    return false;
}
